import { select, Store } from '@ngrx/store';
import { skipWhile, switchMap, tap } from 'rxjs';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  selectIsInitializing,
  selectIsLoggedIn,
} from './core/state/user-session/user-session.selectors';
import { RootState } from './core/state/shared/root-state.interface';
import { inject } from '@angular/core';
import { getSession } from './core/state/user-session/user-session.actions';

export const authGuard = (activatedRoute: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const store = inject(Store<RootState>);
  return store.pipe(select(selectIsInitializing)).pipe(
    tap((isInit) => {
      if (isInit) {
        store.dispatch(getSession());
      }
    }),
    skipWhile((isInit) => isInit),
    switchMap(() => {
      return store.pipe(select(selectIsLoggedIn)).pipe(
        tap((isLoggedIn) => {
          if (activatedRoute.queryParams['token']) {
            return router.navigate(['/pairing'], {
              queryParams: {
                token: activatedRoute.queryParams['token'],
                start: new Date().getTime(),
              },
            });
          }
          return isLoggedIn || router.navigate(['/login']);
        }),
      );
    }),
  );
};
